import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SelectorItem } from '@app/component/selector/selector.component';
import { RouteComponent } from '@app/route/route.component';
import { HeaderService } from '@app/service/header/header.service';
import {
  PayInAdvancePaymentJson,
  PIAService,
} from '@app/service/pay-in-advance/pay-in-advance.service';
import { StateService } from '@app/service/state/state.service';
import { ValuePipe } from '@app/shared/pipe/value.pipe';

@Component({
  selector: 'app-pia-success',
  templateUrl: './pia-success.component.html',
  styleUrls: ['../../page-shared.css', './pia-success.component.scss'],
})
export class PiaSuccessComponent extends RouteComponent implements OnInit {
  constructor(
    protected router: Router,
    protected route: ActivatedRoute,
    protected stateService: StateService,
    protected headerService: HeaderService,
    private valuePipe: ValuePipe,
    private PIAService: PIAService
  ) {
    super(router, route, stateService, headerService);
  }
  selectorItems: SelectorItem[] = null;
  modalActive: boolean = false;
  payInAdvancePaymentJson: PayInAdvancePaymentJson = null;
  loading: boolean = true;
  email: string = '';
  successUrl: string;

  async ngOnInit(): Promise<void> {
    this.payInAdvancePaymentJson =
      await this.PIAService.commitToPiAPayment().toPromise();
    const userInfo = await this.PIAService.getActiveUserInfo().toPromise();
    this.email = userInfo?.email.value;
    this.selectorItems = [
      {
        tab: 'Purchase',
        title: 'Summary',
        descriptions: [{ text: this.state.paymentInformation.description }],
        lineItems: this.state.paymentInformation?.lineItems,
        totalValue: `Total incl. VAT: ${this.valuePipe.transform(
          this.state.totalCheckoutValue
        )}`,
      },
      {
        tab: 'Terms',
        title: 'Pay in advance',
        descriptions: [
          {
            text: `With Zaver’s Pay in Advance your order will be processed as soon as we receive payment from you. Use the payment information displayed on the order confirmation page here in the checkout, or find the email and pdf invoice sent to the email address you specified.`,
          },
        ],
      },
    ];
    this.successUrl = this.state.merchantUrls?.onSuccessUrl;
    this.loading = false;
  }
  public openTab(url: string): void {
    window.open(url);
  }

  toggleModal(): void {
    this.modalActive = !this.modalActive;
  }

  onRouteToSuccessUrl(): void {
    window.location.href = this.successUrl;
  }
}
